export default __webpack_public_path__ + "static/media/furniture-bg-3.c04a7de9.png";